/** Marketing chrome surface — see sites/lumora/src/styles.css token header. */
export type MarketingSurface = "flagship" | "utility";

/** Hash-router pathname → `data-surface` for shared header/main styling. */
export function marketingSurfaceForPath(pathname: string): MarketingSurface {
  if (pathname === "/" || pathname === "") return "flagship";
  return "utility";
}
